import {
  UpdateMonitoringUsersPayload,
  UpdateMonitoringUsersResponse,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useUpdateTenantMonitoringUsers(
  tenantId: string,
  onSuccess?: (data: UpdateMonitoringUsersResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants/${tenantId}/monitoring-users`;
  const request = new Request(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return useAuthenticatedMutation<
    UpdateMonitoringUsersResponse,
    UpdateMonitoringUsersPayload
  >(request, {
    onSuccessInvalidationKeys: [
      ['admin-tenant-details', tenantId],
      ['admin-tenant-monitoring-users', tenantId],
      ['admin-tenants'],
    ],
    onSuccess,
    onError,
  });
}

export default useUpdateTenantMonitoringUsers;
